import React, { useState } from 'react';
import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material';
import './Input.css';

const Input = ({
  type = 'text',
  name,
  placeholder,
  value,
  onChangeHandler,
  icon,
  required = false,
  additionalClass = '',
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword   = type === 'password';
  const resolvedType = isPassword ? (showPassword ? 'text' : 'password') : type;

  const inputClasses = ['input-field', icon ? 'has-icon' : '', additionalClass]
    .filter(Boolean).join(' ');

  return (
    <div className="input-container">
      {icon && <span className="input-icon">{icon}</span>}

      <input
        type={resolvedType}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChangeHandler}
        className={inputClasses}
        required={required}
      />

      {isPassword && (
        <button
          type="button"
          className="input-eye"
          onClick={() => setShowPassword((v) => !v)}
          tabIndex={-1}
          aria-label={showPassword ? 'Masquer' : 'Afficher'}
        >
          {showPassword
            ? <VisibilityOutlined />
            : <VisibilityOffOutlined />
          }
        </button>
      )}
    </div>
  );
};

export default Input;